import React, { Fragment, useEffect, useState, useCallback } from 'react'
import Button from '@mui/material/Button'
import PageShell from '../../themes/components/PageShell';
import PageHeader from '../../themes/components/PageHeader';
import PageContent from '../../themes/components/PageContent';
import Action from '../../themes/components/Action';
import ResponsiveDataGrid from '../../themes/components/ResponsiveDataGrid';
import Form from '../../themes/components/Form';
import FormSection from '../../themes/components/FormSection';
import FormRow from '../../themes/components/FormRow';
import FormField from '../../themes/components/FormField';
import FormActions from '../../themes/components/FormActions';
import LocalSubnav from '../../themes/components/LocalSubnav';
import Box from '@mui/material/Box';
import {
    GetCompanies, AddCompany, GetCompanyById, AddDocument, AddRemark, UpdateCompany, GetCompanyInvoices, GetCompanyAgreements,
    GetCompanyBalances, AddBalance, GetUnpaidItems
} from '../../REST/company'
import {
    DataGrid, GridToolbarContainer,
    GridToolbarExport,
    gridClasses,
} from '@mui/x-data-grid';
import { Routes, Route, useNavigate, useLocation, useParams } from 'react-router-dom'
import AuthProvider from '../Authentication/authProvider'
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from "yup";
import { useForm, Controller, useFormState } from "react-hook-form";
import TextField from '@mui/material/TextField';
import FormControlLabel from '@mui/material/FormControlLabel';
import DocumentView from '../Utilities/documents';
import RemarksView from '../Utilities/remarks';
import SaveIcon from '@mui/icons-material/Save';
import ReceiptIcon from '@mui/icons-material/Receipt';
import ArticleIcon from '@mui/icons-material/Article';
import FileCopyIcon from '@mui/icons-material/FileCopy';
import NoteIcon from '@mui/icons-material/Note';
import PersonIcon from '@mui/icons-material/Person';
import Access from '../../Utils/authorize';
import Users from './users';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import { getOptions } from '../Agreements'
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import NativeSelect from '@mui/material/NativeSelect';
import FormHelperText from '@mui/material/FormHelperText';
import Dialog from '@mui/material/Dialog';
import CloseIcon from '@mui/icons-material/Close';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Slide from '@mui/material/Slide';
import Balances from './balances'
import BackIcon from '@mui/icons-material/ArrowBack';
import MenuIcon from '@mui/icons-material/Menu';
import EmailIcon from '@mui/icons-material/Email';
import SendTemplateDialog from '../../themes/components/SendTemplateDialog';
import { getAmount } from '../../helpers/amount';
import { dateFormat } from '../../helpers/dates';
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import DatePicker from '@mui/lab/DatePicker';
import Switch from '@mui/material/Switch';
import { useTheme, useMediaQuery } from '@mui/material';
import { handleErr } from '../../helpers/errors';
import AddIcon from '@mui/icons-material/Add'
import { dateCompare } from '../../helpers/dates';
const phoneRegExp = /^(\s*|\d+)$/

function CustomToolbar() {
    return (
        <GridToolbarContainer className={gridClasses.toolbarContainer}>
            <GridToolbarExport />
        </GridToolbarContainer>
    );
}

function CompanyList() {

    const navigate = useNavigate()

    const columns = [
        { field: 'name',         headerName: 'Name',             flex: 0.6, minVisible: 'xs' },
        { field: 'description',  headerName: 'Description',      flex: 0.7, minVisible: 'sm' },
        { field: 'email',        headerName: 'Email',            flex: 0.6, minVisible: 'md' },
        { field: 'phone',        headerName: 'Phone #',          flex: 0.4, minVisible: 'md' },
        { field: 'contactname',  headerName: 'Contact Name',     flex: 0.5, minVisible: 'lg' },
        { field: 'contactphone', headerName: 'Contact Phone #',  flex: 0.5, minVisible: 'lg' },
    ];

    const fetchCompanies = useCallback(async (page, limit, filters, sort) => {
        const params = { page, limit }

        if (Object.keys(filters).length > 0) {
            params.filters = JSON.stringify(filters)
        }

        if (sort) {
            params.sort = JSON.stringify(sort)
        }

        const result = await GetCompanies(params);

        if (result.data?.data) {
            return {
                data: result.data.data.map(e => ({ ...e, id: e._id })),
                pagination: result.data.pagination
            };
        }

        if (Array.isArray(result.data)) {
            const transformed = result.data.map(e => ({ ...e, id: e._id }));
            return { data: transformed, pagination: { total: transformed.length } };
        }

        return { data: [], pagination: { total: 0 } };
    }, []);

    const handleRowClick = (row) => {
        navigate('/companies/' + row.id);
    };

    return (
        <PageShell>
            <PageHeader
                title="Tenants"
                back
                onBack={() => navigate(-1)}
                actions={
                    Access.isAdmin('Company') && (
                        <Action
                            primary
                            icon={<AddIcon />}
                            label="Add Tenant"
                            onClick={() => navigate('/companies/add')}
                        />
                    )
                }
            />
            <PageContent fill>
                <ResponsiveDataGrid
                    columns={columns}
                    fetchData={fetchCompanies}
                    initialPageSize={10}
                    pageSizeOptions={[10, 25, 50, 100]}
                    onRowClick={handleRowClick}
                    enableExport={true}
                    clientSort={{ field: 'name', order: 'asc' }}
                />
            </PageContent>
        </PageShell>
    );
}

/*
function CompanyList() {
    const navigate = useNavigate()
    const [rows, setRows] = useState([])
    const [page, setPage] = useState(10)

    const columns = [
        { field: 'id', headerName: 'ID', flex: 0.5, hide: true},
        { field: 'name', headerName: 'Name', flex: 0.5},
        { field: 'description', headerName: 'Description', flex: 0.5},
        { field: 'email', headerName: 'Email',  flex: 0.5},
        { field: 'phone', headerName: 'Phone #',  flex: 0.5},
        { field: 'contactname', headerName: 'Contact Name',  flex: 0.5},
        { field: 'contactphone', headerName: 'Contact Phone #',  flex: 0.5}
    ];

    useEffect(() => {
        (async () => {
            const result = await GetCompanies()
            setRows(result.data.map(e => {
                return { ...e, id: e._id }
            }))
        })()
    }, [])

    const handleLink = (id) => navigate('/companies/' + id)

    return (
        <div style={{ display: 'flex', height: '100%' }}>
            <div style={{ flexGrow: 1 }}>
                {Access.isAdmin('Company') && <Button variant='outlined' endIcon={<AddIcon />} onClick={() => handleLink('add')}>Add Owner</Button>}
                <Button style={{ float: 'right' }} variant='outlined' onClick={() => navigate('/')} startIcon={<BackIcon />}>Back</Button>}
                <DataGrid
                    rows={rows}
                    columns={columns}
                    pageSize={page}
                    rowsPerPageOptions={[10, 25, 50, 100]}
                    onRowClick={(p) => handleLink(p.id)}
                    onPageSizeChange={e => setPage(e)}
                    components={{
                        Toolbar: CustomToolbar,
                    }}
                />
            </div>
        </div>
    );
}
*/

export default function CompanyView() {
    const location = useLocation()

    return <Fragment>
        {location.pathname === '/companies' && <CompanyList />}
        <Routes>
            <Route path='add' element={<AuthProvider><AddCompanyView /></AuthProvider>} />
            <Route path=':id' element={<AuthProvider><EditCompanyView /></AuthProvider>} />
            <Route path=':id/invoices' element={<AuthProvider><CompanyInvoices /></AuthProvider>} />
            <Route path=':id/agreements' element={<AuthProvider><CompanyAgreements /></AuthProvider>} />
            <Route path=':id/balances' element={<AuthProvider><AccountBalance /></AuthProvider>} />
        </Routes>
    </Fragment>
}

const companySchema = yup.object({
    name:         yup.string().trim().required(),
    description:  yup.string().trim().required(),
    address1:     yup.string().trim(),
    address2:     yup.string(),
    email:        yup.string().email().required(),
    isPaperless:  yup.boolean(),
    phone:        yup.string().trim().matches(phoneRegExp, 'Phone number is not valid'),
    contactname:  yup.string().trim(),
    contactphone: yup.string().trim().matches(phoneRegExp, 'Phone number is not valid'), // fixed typo: was contcatphone
    status:       yup.string(),
}).required();

function AddCompanyView() {
    const navigate = useNavigate()

    const methods = useForm({
        resolver: yupResolver(companySchema),
        defaultValues: {
            name: '', description: '', address1: '', address2: '',
            isPaperless: false, email: '', phone: '',
            contactname: '', contactphone: '', status: '',
        }
    });

    const { reset, setError } = methods
    const { isDirty } = useFormState({ control: methods.control })

    useEffect(() => { reset() }, [reset])
    useEffect(() => { reset(methods.getValues()) }, [isDirty]) // eslint-disable-line

    const onSubmit = data => {
        AddCompany(data)
            .then(res => { if (res.data?._id) { reset(); navigate('/companies/' + res.data._id) } })
            .catch(err => handleErr(err, setError))
    }

    return (
        <PageShell>
            <PageHeader
                title="Add Tenant"
                back
                onBack={() => navigate('/companies')}
            />
            <PageContent>
                <Form methods={methods} onSubmit={onSubmit}>
                    <FormSection title="Tenant Details">
                        <FormRow>
                            <FormField name="name"        label="Name"        required xs={12} md={8} />
                            <FormField name="isPaperless" label="Paperless"   type="checkbox" xs={12} md={4} />
                            <FormField name="description" label="Description" required xs={12} />
                        </FormRow>
                    </FormSection>

                    <FormSection title="Contact & Address" divider>
                        <FormRow>
                            <FormField name="email"        label="Email"         required xs={12} sm={6} />
                            <FormField name="phone"        label="Phone"         xs={12} sm={6} />
                            <FormField name="contactname"  label="Contact Name"  xs={12} sm={6} />
                            <FormField name="contactphone" label="Contact Phone" xs={12} sm={6} />
                            <FormField name="address1"     label="Address Line 1" xs={12} />
                            <FormField name="address2"     label="Address Line 2" xs={12} />
                        </FormRow>
                    </FormSection>

                    <FormActions>
                        <Button onClick={() => navigate('/companies')}>Cancel</Button>
                        <Button variant="contained" type="submit" startIcon={<SaveIcon />}>Save</Button>
                    </FormActions>
                </Form>
            </PageContent>
        </PageShell>
    )
}

const STATUS_OPTIONS = [
    { label: 'Approval Needed', value: 'Approval Needed' },
    { label: 'Active',          value: 'Active' },
    { label: 'Inactive',        value: 'Inactive' },
];

function EditCompanyView() {
    const { id } = useParams()
    const navigate = useNavigate()
    const theme = useTheme()
    const isMobile = useMediaQuery(theme.breakpoints.down('md'))
    const [data, setData] = useState({});
    const [refresh, setRefresh] = useState(false);
    const [documentsOpen, setDocumentsOpen] = useState(false);
    const [remarksOpen, setRemarksOpen] = useState(false);
    const [usersOpen, setUsersOpen] = useState(false);
    const [toolsOpen, setToolsOpen] = useState(false);
    const [sendEmailOpen, setSendEmailOpen] = useState(false);

    const [availAmount, setAvailAmount] = useState(0);

    const methods = useForm({
        resolver: yupResolver(companySchema),
        defaultValues: {
            name: '', description: '', address1: '', address2: '',
            email: '', isPaperless: false, status: '',
            phone: '', contactname: '', contactphone: '',
        }
    });

    const { reset, setError } = methods
    const { isDirty } = useFormState({ control: methods.control })

    useEffect(() => {
        (async () => {
            const result = await GetCompanyById(id)
            setData(result.data)
            reset(result.data)
        })()
    }, [id, refresh, reset])

    useEffect(() => {
        (async () => {
            try {
                const result = await GetCompanyBalances(id)
                let rawBalance = 0
                result.data.forEach(e => {
                    rawBalance = rawBalance + (e.type === 'Credit' ? e.amount : -(e.amount))
                })

                let overdueSum = 0
                const unpaidResult = await GetUnpaidItems(id)
                if (Array.isArray(unpaidResult.data)) {
                    unpaidResult.data.forEach(inv => {
                        if (inv.status === 'Overdue') {
                            inv.lineItems.forEach(item => {
                                if (!item.receiptId) {
                                    overdueSum += (item.charges * item.amount)
                                }
                            })
                        }
                    })
                }
                setAvailAmount(rawBalance + overdueSum)
            } catch (err) {
                console.error("Error calculating balance in EditCompany:", err)
            }
        })()
    }, [id, refresh])

    useEffect(() => { reset(methods.getValues()) }, [isDirty]) // eslint-disable-line

    const onSubmit = data => {
        UpdateCompany(id, data).catch(err => handleErr(err, setError))
    }

    const toggleRefresh = () => setRefresh(r => !r)
    const addDocument = doc => AddDocument(id, doc).then(toggleRefresh)
    const addRemark   = doc => AddRemark(id, doc).then(toggleRefresh)

    const isExt = !Access.isAdmin('Company')

    return (
        <PageShell>
            <PageHeader
                title="Edit Company"
                back
                onBack={() => navigate(-1)}
                actions={
                    <Box sx={{ display: 'flex', gap: 1.5, alignItems: 'center' }}>
                        <Balances availAmount={availAmount} onRefresh={toggleRefresh} />
                        {isMobile && (
                            <Action
                                primary
                                icon={<MenuIcon />}
                                label="Company Tools"
                                onClick={() => setToolsOpen(true)}
                            />
                        )}
                    </Box>
                }
            />
            <PageContent>
                <DocumentView
                    module="Company"
                    fullWidth
                    docIds={data.documents}
                    onUpload={e => addDocument(e._id)}
                    open={documentsOpen}
                    onClose={() => setDocumentsOpen(false)}
                    showTrigger={false}
                />
                <RemarksView
                    module="Company"
                    fullWidth
                    docIds={data.remarks}
                    onUpload={e => addRemark(e._id)}
                    open={remarksOpen}
                    onClose={() => setRemarksOpen(false)}
                    showTrigger={false}
                />
                <Users
                    open={usersOpen}
                    onClose={() => setUsersOpen(false)}
                    showTrigger={false}
                />
                <SendTemplateDialog
                    open={sendEmailOpen}
                    onClose={() => setSendEmailOpen(false)}
                    module="Company"
                    entityId={id}
                    defaultEmail={data.email || ''}
                />

                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: { xs: 'column', md: 'row-reverse' },
                        gap: 2,
                        alignItems: 'flex-start',
                    }}
                >
                    <LocalSubnav
                        title="Company Tools"
                        mobileLabel="Company Tools"
                        open={toolsOpen}
                        onOpen={() => setToolsOpen(true)}
                        onClose={() => setToolsOpen(false)}
                        showMobileTrigger={false}
                        items={[
                            {
                                key: 'documents',
                                label: 'Documents',
                                icon: <FileCopyIcon />,
                                onClick: () => setDocumentsOpen(true),
                            },
                            {
                                key: 'remarks',
                                label: 'Remarks',
                                icon: <NoteIcon />,
                                onClick: () => setRemarksOpen(true),
                            },
                            {
                                key: 'users',
                                label: 'Users',
                                icon: <PersonIcon />,
                                onClick: () => setUsersOpen(true),
                            },
                            {
                                key: 'invoices',
                                label: 'Invoices',
                                icon: <ReceiptIcon />,
                                onClick: () => navigate('invoices'),
                                dividerBefore: true,
                            },
                            {
                                key: 'agreements',
                                label: 'Lease Agreements',
                                icon: <ArticleIcon />,
                                onClick: () => navigate('agreements'),
                            },
                            {
                                key: 'balances',
                                label: 'Account Balance',
                                icon: <AccountBalanceIcon />,
                                onClick: () => navigate('balances'),
                            },
                            {
                                key: 'send-email',
                                label: 'Send Email',
                                icon: <EmailIcon />,
                                onClick: () => setSendEmailOpen(true),
                                dividerBefore: true,
                            },
                        ]}
                    />

                    <Box sx={{ flex: '1 1 auto', minWidth: 0, width: '100%' }}>
                        <Form methods={methods} onSubmit={onSubmit}>
                            <FormSection title="Company Details">
                                <FormRow>
                                    {!isExt && (
                                        <FormField
                                            name="status" label="Status" type="select"
                                            options={STATUS_OPTIONS} xs={12} md={4}
                                        />
                                    )}
                                    <FormField
                                        name="name" label="Name" required
                                        disabled={isExt}
                                        xs={12} md={isExt ? 12 : 8}
                                    />
                                    <FormField
                                        name="description" label="Description" required
                                        disabled={isExt}
                                        xs={12}
                                    />
                                    <FormField name="isPaperless" label="Paperless" type="checkbox" xs={12} md={4} />
                                </FormRow>
                            </FormSection>

                            <FormSection title="Contact & Address" divider>
                                <FormRow>
                                    <FormField name="email"        label="Email"          required xs={12} sm={6} />
                                    <FormField name="phone"        label="Phone"          xs={12} sm={6} />
                                    <FormField name="contactname"  label="Contact Name"   xs={12} sm={6} />
                                    <FormField name="contactphone" label="Contact Phone"  xs={12} sm={6} />
                                    <FormField name="address1"     label="Address Line 1" xs={12} />
                                    <FormField name="address2"     label="Address Line 2" xs={12} />
                                </FormRow>
                            </FormSection>

                            <FormActions>
                                <Button onClick={() => navigate(-1)}>Cancel</Button>
                                <Button variant="contained" type="submit" startIcon={<SaveIcon />}>Save</Button>
                            </FormActions>
                        </Form>
                    </Box>
                </Box>
            </PageContent>
        </PageShell>
    )
}




function CompanyInvoices() {

    const navigate = useNavigate()
    const [rows, setRows] = useState([])
    const { id } = useParams()
    const [loading, setLoading] = useState(false)
    const [pageSize, setPageSize] = useState(10)
    const [currentPage, setCurrentPage] = useState(0)
    const [rowCount, setRowCount] = useState(0)

    const amountParser = (params) => getAmount(params.value)

    const dateParser = (params) => dateFormat(params.value)

    const columns = [
        { field: 'tenantId', headerName: 'Company Name', flex: 0.5, hide: true },
        { field: 'name', headerName: 'Invoice Name', flex: 0.5 },
        { field: 'invoiceNumber', headerName: 'Invoice Number', flex: 0.5 },
        { field: 'paymentDate', headerName: 'Payment Date', flex: 0.5, type: 'date', renderCell: dateParser },
        { field: 'dueDate', headerName: 'Due Date', flex: 0.5, type: 'date', renderCell: dateParser },
        { field: 'status', headerName: 'Status', flex: 0.5, type: 'singleSelect', valueOptions: ['Created', 'Unpaid', 'Partially Paid', 'Paid', 'Overdue', 'Payment Reversed', 'Cancelled'] },
        { field: 'amountDue', headerName: 'Amount Due', flex: 0.5, type: 'number', renderCell: amountParser, filterable: false },
        { field: 'amountTotal', headerName: 'Amount Total', flex: 0.5, type: 'number', renderCell: amountParser, filterable: false },
        { field: 'amountPaid', headerName: 'Amount Paid', flex: 0.5, type: 'number', renderCell: amountParser, filterable: false },
    ];

    useEffect(() => {
        (async () => {
            setLoading(true)
            try {
                const response = await GetCompanyInvoices(id, { 
                    page: currentPage + 1,  // Backend uses 1-based pages
                    limit: pageSize 
                })
                const result = response.data
                
                if (Array.isArray(result.data)) {
                    const mappedData = result.data.map(e => {
                        const { lineItems } = e
                        let amountDue = 0.0
                        let amountPaid = 0.0
                        let amountTotal = 0.0
                        lineItems.forEach(each => {
                            const { charges, amount } = each
                            if (each.receiptId) amountPaid = amountPaid + (charges * amount)
                            amountTotal = amountTotal + (charges * amount)
                        })
                        amountDue = amountTotal - amountPaid
                        return { ...e, id: e._id, amountDue, amountPaid, amountTotal }
                    })
                    setRows(mappedData)
                    setRowCount(result.pagination?.total || 0)
                }
            } catch (error) {
                console.error('Error fetching invoices:', error)
            } finally {
                setLoading(false)
            }
        })()
    }, [id, currentPage, pageSize])

    const handleLink = (id) => navigate('/invoices/' + id)

    return (
        <div style={{ display: 'flex', height: '100%' }}>
            <div style={{ flexGrow: 1 }}>
                <DataGrid
                    rows={rows}
                    columns={columns}
                    loading={loading}
                    
                    // Server-side pagination
                    paginationMode="server"
                    rowCount={rowCount}
                    page={currentPage}
                    pageSize={pageSize}
                    onPageChange={(newPage) => setCurrentPage(newPage)}
                    onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
                    rowsPerPageOptions={[10, 25, 50, 100]}
                    
                    onRowClick={(p) => handleLink(p.id)}
                    components={{
                        Toolbar: CustomToolbar,
                    }}
                />
            </div>
        </div>
    );
}


function CompanyAgreements() {

    const navigate = useNavigate()
    const [rows, setRows] = useState([])
    const { id } = useParams()
    const [page, setPage] = useState(10)

    const dateParser = (params) => dateFormat(params.value)

    const columns = [
        { field: 'id', headerName: 'ID', flex: 0.5, hide: true },
        { field: 'title', headerName: 'Account #', flex: 0.5 },
        { field: 'agreementNum', headerName: 'Account Number#', flex: 0.5 },
        { field: 'startDate', headerName: 'Begin Date', flex: 0.5, type: 'date', renderCell: dateParser, sortComparator: (v1, v2) => dateCompare(v1, v2) },
        { field: 'endDate', headerName: 'End Date', flex: 0.5, type: 'date', renderCell: dateParser, sortComparator: (v1, v2) => dateCompare(v1, v2) },
        { field: 'status', headerName: 'Status', flex: 0.5, type: 'singleSelect', valueOptions: ['Active', 'Archived', 'Expiring Soon', 'Expired'] },
    ];

    useEffect(() => {
        (async () => {
            const result = await GetCompanyAgreements(id)
            if (Array.isArray(result.data))
                setRows(result.data.map(e => {
                    return { ...e, id: e._id }
                }))
        })()
    }, [id])

    const handleLink = (id) => navigate('/agreements/' + id)

    return (
        <div style={{ display: 'flex', height: '100%' }}>
            <div style={{ flexGrow: 1 }}>
                <Button variant='outlined' endIcon={<AddIcon />} onClick={() => handleLink('add')}>Add Agreement</Button>
                <Button style={{ float: 'right' }} variant='outlined' onClick={() => navigate(-1)} startIcon={<BackIcon />}>Back</Button>
                <DataGrid
                    rows={rows}
                    columns={columns}
                    pageSize={page}
                    rowsPerPageOptions={[10, 25, 50, 100]}
                    onPageSizeChange={e => setPage(e)}
                    onRowClick={(p) => handleLink(p.id)}
                    components={{
                        Toolbar: CustomToolbar,
                    }}
                />
            </div>
        </div>
    );
}

function AccountBalance() {
    const [rows, setRows] = useState([])
    const { id } = useParams()
    const [availAmount, setAvailAmount] = useState(0)
    const [page, setPage] = useState(10)
    const navigate = useNavigate()

    const [refresh, setRefresh] = useState(false)

    const toggleRefresh = () => setRefresh(refresh => !refresh)

    useEffect(() => {
        toggleRefresh()
    }, [])

    const amountParser = (params) => getAmount(params.value)
    const dateParser = (params) => dateFormat(params.value)

    const columns = [
        { field: 'id', headerName: 'ID', flex: 0.5, hide: true },
        { field: 'accountNum', headerName: 'Account Details', flex: 0.5 },
        // { field: 'routingNum', headerName: 'Routing Number', flex: 0.5 },
        { field: 'type', headerName: 'Balance Type', flex: 0.5, type: 'singleSelect', valueOptions: ['Debit', 'Credit'] },
        { field: 'amount', headerName: 'Amount', flex: 0.5, type: 'number', renderCell: amountParser },
        { field: 'dateApplied', headerName: 'Date Applied', flex: 0.5, type: 'date', renderCell: dateParser, sortComparator: (v1, v2) => dateCompare(v1, v2) },
    ];

    useEffect(() => {
        (async () => {
            const result = await GetCompanyBalances(id)
            let rawBalance = 0
            const rowsMapped = result.data.map(e => {
                rawBalance = rawBalance + (e.type === 'Credit' ? e.amount : -(e.amount))
                return { ...e, id: e._id, createdAt: e.startDate }
            })
            setRows(rowsMapped)

            // Include overdue invoice amounts as positive outstanding balances
            let overdueSum = 0
            try {
                const unpaidResult = await GetUnpaidItems(id)
                if (Array.isArray(unpaidResult.data)) {
                    unpaidResult.data.forEach(inv => {
                        if (inv.status === 'Overdue') {
                            inv.lineItems.forEach(item => {
                                if (!item.receiptId) {
                                    overdueSum += (item.charges * item.amount)
                                }
                            })
                        }
                    })
                }
            } catch (err) {
                console.error("Error fetching unpaid items for balance calculation:", err)
            }

            const finalBalance = rawBalance + overdueSum
            setAvailAmount(finalBalance)
        })()
    }, [id, refresh])


    return (
        <div style={{ display: 'flex', height: '100%' }}>
            <div style={{ flexGrow: 1 }}>
                <div className='d-flex'>
                    <Transaction key={new Date().toISOString()} onRefresh={() => toggleRefresh()} />
                    <Balances availAmount={availAmount} onRefresh={() => toggleRefresh()} />
                    <div style={{ marginLeft: 'auto', display: 'flex', gap: 8, alignItems: 'center' }}>
                        <Button variant='outlined' onClick={() => navigate(-1)} startIcon={<BackIcon />}>Back</Button>
                        <Button variant="outlined">Balance: ${availAmount}</Button>
                    </div>

                </div>
                <DataGrid
                    rows={rows}
                    columns={columns}
                    pageSize={page}
                    rowsPerPageOptions={[10, 25, 50, 100]}
                    onPageSizeChange={e => setPage(e)}
                    components={{
                        Toolbar: CustomToolbar,
                    }}
                />
            </div>
        </div>
    );
}

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});



function Transaction({ onRefresh }) {
    const [open, setOpen] = React.useState(false);
    const { id } = useParams()

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const schema = yup.object({
        accountNum: yup.string().trim().required(),
        routingNum: yup.string().trim().required(),
        amount: yup.number().required(),
        type: yup.string().trim().required(),
        dateApplied: yup.string().trim().required()

    }).required();

    const { control, handleSubmit, formState: { errors }, clearErrors, reset, getValues } = useForm({
        defaultValues: {
            accountType: true,
            accountNum: '',
            routingNum: '',
            amount: '',
            type: '',
            dateApplied: ''
        },
        resolver: yupResolver(schema)
    });

    const { isDirty } = useFormState({ control })


    const checklabels = {
        accountNum: 'Account Number',
        routingNum: 'Routing Number',
    }

    const cashlabels = {
        accountNum: 'Paid By',
        routingNum: 'comments',
    }

    useEffect(() => {
        clearErrors()
    }, [open, clearErrors])

    useEffect(() => {
        reset(getValues())
    }, [isDirty, getValues, reset])

    const onSubmit = async (data) => {
        await AddBalance({ ...data, tenantId: id })
        setOpen(false);
        onRefresh()
    }

    const isError = (val) => val !== undefined && val !== null && typeof val === 'object'

    return (
        Access.isAdmin('Company') && <div>
            <Button variant="outlined" onClick={handleClickOpen} endIcon={<AddIcon />}>
                Add Record
            </Button>
            <Dialog
                fullScreen
                open={open}
                onClose={handleClose}
                TransitionComponent={Transition}
            >
                <AppBar sx={{ position: 'relative' }}>
                    <Toolbar>
                        <IconButton
                            edge="start"
                            color="inherit"
                            onClick={handleClose}
                            aria-label="close"
                        >
                            <CloseIcon />
                        </IconButton>
                        <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
                            Add Record
                        </Typography>
                    </Toolbar>
                </AppBar>
                <div className='row'>
                    <div className='col-lg-3 col-md-4 col-sm-6 col-xs-12 mx-auto'>
                        <LocalizationProvider dateAdapter={AdapterDateFns}>
                            <Controller name="accountType" control={control} render={({ field }) => <FormControlLabel {...field} labelPlacement={getValues('accountType') ? 'start' : 'end'} control={<Switch checked={field.value} />} label={getValues('accountType') ? 'Cash' : 'Check'} />} />
                            <Controller name="accountNum" control={control} render={({ field }) => <TextField margin='dense' variant='standard' error={isError(errors.accountNum)} helperText={errors.accountNum && errors.accountNum.message} type={getValues('accountType') ? "string" : "number"} fullWidth label={getValues('accountType') ? cashlabels.accountNum : checklabels.accountNum}{...field} />} />
                            <Controller name="routingNum" control={control} render={({ field }) => <TextField margin='dense' variant='standard' error={isError(errors.routingNum)} helperText={errors.routingNum && errors.routingNum.message} type={getValues('accountType') ? "string" : "number"} fullWidth label={getValues('accountType') ? cashlabels.routingNum : checklabels.routingNum} {...field} />} />
                            <Controller name="amount" control={control} render={({ field }) => <TextField margin='dense' variant='standard' error={isError(errors.amount)} helperText={errors.amount && errors.amount.message} fullWidth type='number' label='Amount' {...field} />} />
                            <Controller name="type" control={control} render={({ field }) => <FormControl error={isError(errors.type)} variant='standard' margin='dense' fullWidth><InputLabel shrink>Balance Type</InputLabel><NativeSelect {...field} >{getOptions(['Credit', 'Debit'])}</NativeSelect>{errors.type && <FormHelperText>{errors.type.message}</FormHelperText>}</FormControl>} />
                            <Controller name="dateApplied" control={control} render={({ field }) => <DatePicker variant='standard' margin='dense' helperText={errors.dateApplied && errors.dateApplied.message} fullWidth label='Applied Date' renderInput={(params) => <TextField fullWidth variant='standard' {...params} error={isError(errors.dateApplied)} onChange={field.onChange} />} {...field} />} />
                            <Button variant='outlined' onClick={handleSubmit(onSubmit)}>SAVE</Button>
                        </LocalizationProvider>

                    </div>
                </div>
            </Dialog>
        </div>
    );
}
